import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getMessaging } from 'firebase/messaging'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyD50PMbcHpxjAWZH0kZeUIlhv6y7N616R0',
  authDomain: 'notification-bba3d.firebaseapp.com',
  projectId: 'notification-bba3d',
  storageBucket: 'notification-bba3d.appspot.com',
  messagingSenderId: '1008424088647',
  appId: '1:1008424088647:web:61a01776fb56858803ed62',
  measurementId: 'G-J6X36GRQPZ'
}

const fbApp = initializeApp(firebaseConfig)

const auth = getAuth(fbApp)

const messaging = getMessaging(fbApp)

const firebase = getFirestore(fbApp)

const storage = getStorage(fbApp)

export { firebaseConfig, fbApp, auth, firebase, messaging, storage }
